// Modal actions
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
// New design AAF Modal Types
export const AAF_MODAL_ERROR = 'AAF_MODAL_ERROR';
export const AAF_MODAL_CHECK_EMAIL = 'AAF_MODAL_CHECK_EMAIL';
export const AAF_MODAL_SUCCESS_PTV = 'AAF_MODAL_SUCCESS_PTV';
export const AAF_MODAL_SUCCESS_PTV_SHORT = 'AAF_MODAL_SUCCESS_PTV_SHORT';
export const AAF_MODAL_SENT_LINK = 'AAF_MODAL_SENT_LINK';
export const AAF_MODAL_ACTIVATE = 'AAF_MODAL_ACTIVATE';
export const AAF_MODAL_MONTHS = 'AAF_MODAL_MONTHS';
export const AAF_MODAL_YEARS = 'AAF_MODAL_YEARS';
export const AAF_MODAL_HUB_SERVICE = 'AAF_MODAL_HUB_SERVICE';
export const AAF_MODAL_STATES = 'AAF_MODAL_STATES';
export const AAF_MODAL_SUCCESS = 'AAF_MODAL_SUCCESS';
export const AAF_MODAL_SUCCESS_SUSCRIPTION = 'AAF_MODAL_SUCCESS_SUSCRIPTION';
export const AAF_MODAL_DOCUMENT_TYPE = 'AAF_MODAL_DOCUMENT_TYPE';
export const AAF_MODAL_SERVICE_TYPE = 'AAF_MODAL_SERVICE_TYPE';
export const AAF_MODAL_TEXLMEX_ACTIVATE = 'AAF_MODAL_TEXLMEX_ACTIVATE';
export const AAF_MODAL_CHANGE_PAYMENT_METHOD = 'AAF_MODAL_CHANGE_PAYMENT_METHOD';
export const AAF_MODAL_DELETE_PROFILE = 'AAF_MODAL_DELETE_PROFILE';
export const AAF_MODAL_PROFILE = 'AAF_MODAL_PROFILE';
export const AAF_MODAL_PIN_INFO = 'AAF_MODAL_PIN_INFO';
export const AAF_MODAL_PLAY_OPTIONS = 'AAF_MODAL_PLAY_OPTIONS';
export const AAF_MODAL_SUSPENDED_ACCOUNT = 'AAF_MODAL_SUSPENDED_ACCOUNT';
export const AAF_MODAL_LANDING_STB = 'AAF_MODAL_LANDING_STB';

export const MODAL_DELETE_TV_CHANNEL = 'MODAL_DELETE_TV_CHANNEL';
export const MODAL_DELETE_LAST_SEEN = 'MODAL_DELETE_LAST_SEEN';
export const MODAL_DELETE_FAVORITE = 'MODAL_DELETE_FAVORITE';
export const MODAL_DELETE_RECORDINGS = 'MODAL_DELETE_RECORDINGS';

// Modal types
export const MODAL_DESCONEXION = 'DESCONEXION';
export const MODAL_EXIT = 'EXIT';
export const MODAL_PPE = 'PPE';
export const MODAL_ERROR = 'ERROR';
export const MODAL_ERROR_IP_TELMEX = 'ERROR_IP_TELMEX';
export const MODAL_REINTENTO = 'REINTENTO';
export const MODAL_ACTION = 'ACTION';
export const MODAL_PIN = 'PIN';
export const MODAL_PIN_RECOVERY = 'MODAL_PIN_RECOVERY';
export const MODAL_PURCHASE_SERIE = 'MODAL_PURCHASE_SERIE';
export const MODAL_SUCCESS = 'SUCCESS';
export const MODAL_REMINDER_PIN = 'MODAL_REMINDER_PIN';
export const MODAL_SOCIAL_LEVEL = 'MODAL_SOCIAL_LEVEL';
export const MODAL_LANGUAGES = 'MODAL_LANGUAGES';
export const MODAL_LANGUAGES_LIVE = 'MODAL_LANGUAGES_LIVE';
export const MODAL_FILTERS_LIVE = 'MODAL_FIlTERS_LIVE';
export const MODAL_FILTERS_LIVE_CATEGORIES = 'MODAL_FIlTERS_LIVE_CATEGORIES';
export const MODAL_OPTIONS_EVENT = 'MODAL_OPTIONS_EVENT';
export const MODAL_OPTIONS_EPISODES = 'MODAL_OPTIONS_EPISODES';
export const MODAL_BORRAR_CONTENIDO = 'BORRAR_CONTENIDO';
export const MODAL_ACCIONES_CONTENIDO = 'ACCIONES_CONTENIDO';
export const MODAL_BORRAR_RECORDATORIO = 'BORRAR_RECORDATORIO';
export const MODAL_CONFIRM_PURCHASE = 'CONFIRM_PURCHASE';
export const MODAL_ACCIONES_RECORDATORIO = 'ACCIONES_RECORDATORIO';
export const MODAL_LANGUAGE = 'ACCIONES_IDIOMA';
export const MODAL_MUSIC_FILTER = 'ACCIONES_MUSIC_FILTER';
export const MODAL_PROFILE = 'MODAL_PROFILE';
export const MODAL_ACCIONES_CANALES = 'ACCIONES_CANALES';
export const MODAL_BORRAR_CANAL = 'BORRAR_CANAL';
export const MODAL_EPISODE_SELECT = 'MODAL_EPISODE_SELECT';
export const MODAL_GENERIC = 'MODAL_GENERIC';
export const MODAL_END_PLAYER = 'MODAL_END_PLAYER';
export const MODAL_END_PLAYER2 = 'MODAL_END_PLAYER2';
export const MODAL_END_PLAYER_CATCHUP = 'MODAL_END_PLAYER_CATCHUP';
export const MODAL_TIMEOUT_EVENT = 'MODAL_TIMEOUT_EVENT';
export const MODAL_MUSIC_CONTEXTUAL_MENU = 'ACCIONES_MENU_CONTEXTUAL';
export const MODAL_DROPDOWN = 'ACCIONES_DROPDOWN';
export const MODAL_KEYBOARD = 'ACCIONES_KEYBOARD';
export const MODAL_ACCEPT_TERM = 'ACCIONES_ACCEPT_TERM';
export const MODAL_ACCEPT_TERMG3 = 'MODAL_ACCEPT_TERMG3';
export const MODAL_TERM_AND_COND = 'TERM_AND_COND';
export const MODAL_POLITICAS = 'MODAL_POLITICAS';
export const MODAL_LICENCIA_DE_USO = 'MODAL_LICENCIA_DE_USO';
export const MODAL_POLITICA_DE_PRIVACIDAD = 'MODAL_POLITICA_DE_PRIVACIDAD';
export const MODAL_TERMINOS_Y_CONDICIONES = 'MODAL_TERMINOS_Y_CONDICIONES';
export const MODAL_PRIVACY = 'PRIVACY';
export const MODAL_LICENSE = 'LICENSE';
export const MODAL_UPDATE_EMAIL = 'MODAL_UPDATE_EMAIL';
export const MODAL_COUNTRIES_FILTER = 'ACCIONES_COUNTRIES_FILTER';
export const MODAL_CITIES_FILTER = 'ACCIONES_CITIES_FILTER';
export const MODAL_SHOW_DETAILS = 'ACCIONES_VER_DETALLES';
export const MODAL_REMOTE_CONTROL = 'MODAL_REMOTE_CONTROL';
export const MODAL_EPG = 'MODAL_EPG';
export const MODAL_CHANNEL_EPG = 'MODAL_CHANNEL_EPG';
export const MODAL_VERSION = 'MODAL_VERSION';
export const MODAL_RECORD_SERIES = 'MODAL_RECORD_SERIES';
export const MODAL_RECORD_SERIES_CONTENT = 'MODAL_RECORD_SERIES_CONTENT';
export const MODAL_PROMOTION_TELMEX_TELCEL = 'MODAL_PROMOTION_TELMEX_TELCEL';
export const MODAL_REGISTER_NET = 'MODAL_REGISTER_NET';
export const MODAL_FILTER = 'MODAL_FILTER';
export const AAF_MODAL_RESEND_EMAIL = 'AAF_MODAL_RESEND_EMAIL';
export const MODAL_SEASON_SELECTOR = 'MODAL_SEASON_SELECTOR';
export const MODAL_TALENT_CONTENTS = 'MODAL_TALENT_CONTENTS';
export const MODAL_CALL_CENTER = 'MODAL_CALL_CENTER';
export const MODAL_ADDON = 'MODAL_ADDON';
export const MODAL_CHANGING_EPISODE = 'MODAL_CHANGING_EPISODE';
export const MODAL_DEVICES_EXCEEDED = 'MODAL_DEVICES_EXCEEDED';
export const MODAL_INACTIVITY = 'MODAL_INACTIVITY';
export const MODAL_KEEP_WATCHING = 'MODAL_KEEP_WATCHING';
export const MODAL_ACTUALIZATION_EPGVERSION = 'MODAL_ACTUALIZATION_EPGVERSION';
export const MODAL_FAIL_FILTER_TALENTS = 'MODAL_FAIL_FILTER_TALENTS';

//2FA modals
export const AAF_MODAL_ACTUALIZA_TUS_DATOS_2FA = "AAF_MODAL_ACTUALIZA_TUS_DATOS_2FA";
export const MODAL_2FA_REMEMBER_CONFIRM_PURCHASE = 'MODAL_2FA_REMEMBER_CONFIRM_PURCHASE';
export const MODAL_2FA_LIMIT_PURCHASES = 'MODAL_2FA_LIMIT_PURCHASES';
export const MODAL_2FA_LIMIT_ATTEMPTS = 'MODAL_2FA_LIMIT_ATTEMPTS';
export const AAF_MODAL_CONFIRM_PURCHASE_60_SECONDS = "AAF_MODAL_CONFIRM_PURCHASE_60_SECONDS";
export const MODAL_2FA_EXPIRED_CODE = 'MODAL_2FA_EXPIRED_CODE';
export const MODAL_ONLINE_DEBT = 'MODAL_ONLINE_DEBT';
export const MODAL_HELP_2FA = 'MODAL_HELP_2FA';

// Modal para login con QR
export const AAF_MODAL_QR_LOGIN = 'AAF_MODAL_QR_LOGIN';

//Mundial
export const AAF_MODAL_CALENDAR_PHASE = 'AAF_MODAL_CALENDAR_PHASE';
export const MODAL_MATCH_DETAIL = 'MODAL_MATCH_DETAIL';
export const MODAL_COUNTRY_DETAILS = 'MODAL_COUNTRY_DETAILS';

export const AAF_MODAL_HBO_PLAYBACK_ERROR = 'AAF_MODAL_HBO_PLAYBACK_ERROR';

//QR payments
export const AAF_MODAL_QR_PAYMENTS = 'AAF_MODAL_QR_PAYMENTS';
//Telmex
export const AAF_MODAL_TELMEX_MESSAGE_METHOD_PAYMENT = 'AAF_MODAL_TELMEX_MESSAGE_METHOD_PAYMENT';

//QR HBO Max
export const AAF_MODAL_ACTIVA_HBO_MAX_QR = 'AAF_MODAL_ACTIVA_HBO_MAX_QR';
export const AAF_MODAL_INICIAL_ACTIVA_HBO_MAX = 'AAF_MODAL_INICIAL_ACTIVA_HBO_MAX';
export const AAF_MODAL_PROMOCION_ACTIVA_HBO_MAX = 'AAF_MODAL_PROMOCION_ACTIVA_HBO_MAX';

export const AAF_MODAL_CHANGE_AAF_TO_CLARO_TV = 'AAF_MODAL_CHANGE_AAF_TO_CLARO_TV';


export const showModal =
    ({ modalType, modalProps }) =>
    (dispatch) => {
        dispatch({
            modalType,
            modalProps,
            type: SHOW_MODAL,
        });
    };



// WEBPACK FOOTER //
// ./src/actions/modal.js